module.exports = __webpack_public_path__ + "static/demo-wanikani-655c46323a6f7e87f75c4e49b13a23c2.png";